import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.min.css";
import { DashboardService } from "@/services";
export default {
  name: "dashboard-currencies-card",
  components: { swiper, swiperSlide },
  props: [],
  data() {
    return {
      windowSize: {
        x: 0,
        y: 0
      },
      currencies: null,
      dashboardCurrenciesLoader: true,
      swiperOption: {
        direction: "horizontal",
        width: 150,
        slidesPerView: 1,
        spaceBetween: 12,
        slidesPerGroup: 1,
        lazy: true,
        autoplay: {
          delay: 4000
        },
        // on: {
        //   resize: () => {
        //     this.windowSize = {
        //       x:
        //         document.getElementById("currenciesContainer").clientWidth *
        //         2.3,
        //       y: document.getElementById("currenciesContainer").clientHeight
        //     };
        //   }
        // }
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
          disabledClass: "custom"
        }
      }
    };
  },
  computed: {},
  mounted() {
    this.getCurrencies();
  },
  methods: {
    getCurrencies() {
      DashboardService.getLatestCurrencies()
        .then(response => {
          this.currencies = response.data.data;
        })
        .finally(() => {
          this.dashboardCurrenciesLoader = false;
        });
    }
  }
};
